<h3 *ngIf="ecashView" class="text-trans-history text-primary d-lg-block d-none text-uppercase">
  {{ 'payment.history.page.title' | translate }}
</h3>

<div class="transaction-container bg-white d-flex flex-column flex-lg-row justify-content-between">
  <fgbcl-date-range-picker [(startDate)]="transactionStartDate" [(endDate)]="transactionEndDate"></fgbcl-date-range-picker>
  <button type="button" class="search-button fw-bold mb-0 d-block border rounded-4 text-white bg-primary" (click)="search()">
    Search
  </button>
</div>

<fgb-transaction-list
  *ngIf="selectedValues"
  [startDate]="selectedValues.start"
  [endDate]="selectedValues.end"
  [memberId]="memberId"
  [transactionType]="selectedValues.type"
></fgb-transaction-list>
